






























import { Component, Vue } from "vue-property-decorator";

@Component
export default class NewsInstanceGroupsDeleteModal extends Vue {
    itemToBeDeleted: string = "";
    name: string = ""

    open(id: string, name: string) {
        this.itemToBeDeleted = id;
        this.name = name;
        this.$bvModal.show("modal-deleteInstanceGroups");
    }

    decline() {
        this.$bvModal.hide("modal-deleteInstanceGroups");
        this.itemToBeDeleted = "";
        this.name = "";
    }

    confirm() {
        this.$bvModal.hide("modal-deleteInstanceGroups");
        this.$emit("delete", this.itemToBeDeleted);
        this.itemToBeDeleted = "";
        this.name = "";
    }
}
